/* eslint-disable @typescript-eslint/naming-convention */

export enum Cursor {
  NO_TOOL,
  SELECT,
  ERASER,
  FILL,
  EDIT_NODE,
  EDIT_TABLE,
  DRAW,
  DRAW_FREE,
  DRAW_TEXT_BOX,
  POINTER,
  HIGHLIGHTER,
  BOUNDING_BOX,
  GRIP,
  REFERENCE_POINT,
  ROTATE_POINT,
  NODE,
}
